import { TextField } from '@mui/material';
import { AddUserFormValues } from '@src/hooks/api/mutations/useUserCreate';
import React from 'react';
import { useFormContext } from 'react-hook-form';

function UsernameField() {
  const {
    register,
    formState: { errors },
  } = useFormContext<AddUserFormValues>();

  return (
    <TextField
      fullWidth
      label='Username'
      {...register('username')}
      error={!!errors.username}
      helperText={errors.username?.message}
      size='small'
    />
  );
}

export default UsernameField;
